import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UmbracoService } from 'src/app/services/umbraco.service';

@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrls: ['./alert-message.component.scss']
})
export class AlertMessageComponent implements OnInit, OnDestroy {

  private componentDestroyed = new Subject();

  Body!: string;
  IsActive!: boolean;

  constructor(private umbracoService: UmbracoService) {

    this.umbracoService.postUmbracoData('nyhetsbanner', ['text', 'aktivt'], '/content/getcontent')
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(
        (response: any[]) => {
          
          if (response.length > 0) {
            var responseObj = response[0];
            if (responseObj.Properties && responseObj.Properties.length > 0) {
              this.Body = responseObj.Properties.find((p:any) => p.Alias === 'text').Value;

              var activeStr = responseObj.Properties.find((p:any) => p.Alias === 'aktivt').Value;
              this.IsActive = activeStr.toLowerCase() === 'true';
            }

          }
        },
        (err: HttpErrorResponse) => {
          console.log(err);
        }

      );

  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(null);
    this.componentDestroyed.unsubscribe();
  }

}
